module.exports = require('@wix/wnp-protobufjs');